<template>
  <!--
    Used to create a collection
  -->
  <div class="collectionElementsAdd">
    <form>
      <div class="form-group">
        <h4 class="m-0 mt-3">
          {{ $t('collectionAddComponent.collection') }} Element
        </h4>
        <hr class="m-0 mb-3">
        <label>{{ $t('key') }}</label>
        <input
          v-model="collectionElement.key"
          v-focus
          :class="['form-control', { 'is-invalid': $validator.errors.has('Key') }]"
          type="text"
        >

        <div
          class="m-0 mt-3"
        >
          <label>{{ $t('staticResourceUploaderComponent.files') }}</label>
          <div class="input-group mb-3">
            <input
              ref="fileInput"
              type="file"
              accept="image/png"  
              class="form-control cursor-pointer rounded"
              @change="getFilesFromInput($event)"
            >
          </div>
        </div>
        <div
          v-if="uploadPercentage > 0"
          class="input-group mb-3"
        >
          <div class="input-prepend mr-3">
            <label style="width:50px;">{{ $t('staticResourceUploaderComponent.progress') }}</label>
          </div>
          <div class="progress">
            <div
              :aria-valuenow="uploadPercentage"
              :style="`width:${ uploadPercentage }%;`"
              class="progress-bar"
              role="progressbar"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              {{ uploadPercentage }} %
            </div>
          </div>
        </div>
        <span
          v-show="errors.has('Name')" 
          class="badge badge-danger"
        >{{ errors.first('Name') }}</span>
      </div>
      <button 
        class="btn btn-primary float-right" 
        :disabled="!file && !collectionElement.key"
        @click.prevent="addAndUploadCollection()"
      >
        <font-awesome-icon
          class="mr-2"
          icon="check"
        />{{ $t('add') }}
      </button>
      <div class="clearfix" />
    </form>
  </div>
</template>

<script>
import { errorMixin } from '@/mixins/errorMixin.js';

export default {
  name: "CollectionsAdd",
  mixins: [
    errorMixin
  ],
  props: {
    collectionId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      collectionElement: {},
      file: null,
      fileName: null,
      //fileNames: null,
      uploadPercentage: null,
      uploadingRightNow: false
    }
  },
  created () {
    this.collectionElement.type = "Flags";
  },
  methods: {
    async addFileCollection () {
       let postObject = {
            'key': this.collectionElement.key,
            'collectionId': this.collectionId,
            'sourceName': this.fileName,
      }
      await this.axios.post(`/VideoPostProcessing/AddImageCollectionElement`, postObject)
        .then((response) => {
          //this.$emit("reload");
          this.collectionElement.id = response.data; //TO BE TESTED
          this.error_clear();
        })
        .catch((error) => {
          this.error_clear();
          this.error_validate(error);
        });
    },
    async uploadFileCollection () {
      this.uploadingRightNow = true;
      this.uploadPercentage = 0;
      let bodyFormData = new FormData();
      bodyFormData.append('formFile', this.file);
      await this.axios.post(`/VideoPostProcessingResource/UploadImageCollectionElement/${this.collectionElement.id}`, 
        bodyFormData,
        { headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: function ( progressEvent ) {
            this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ));
          }.bind(this)
        }
      )
      .then((response) => {
        if (response && response.status && response.status == 200) {
          this.$emit("reload");
          this.$snotify.success(this.$t('staticResourceUploaderComponent.fileSavedMessage'));
        }
      })
      .finally(() => {
        this.uploadingRightNow = false;
        setTimeout(() => {
          this.uploadPercentage = 0;
        }, 2500);
      });
    },
    async addAndUploadCollection (){
      await this.addFileCollection();
      await this.uploadFileCollection();
    },
    getFilesFromInput () {
      this.file = this.$refs.fileInput.files[0];
      this.fileName = this.$refs.fileInput.files[0].name;
      this.uploadPercentage = 0;
    }
  }
}
</script>
<style scoped>
.collectionsAdd .progress {
  display: flex;
  flex: 1 1 auto;
  width: 1%;
  height: 20px;
  font-size: 1rem;
}
</style>
